import React, {ReactNode} from 'react';
import {useAppSelector} from "../../../../hooks/redux";
import {getUser} from "../../../../store/selectors/authSelector";
import {EnumRoles} from "../../../../enums/EnumRoles";
import {checkRole} from "../checkRole";

interface IProps {
    children: ReactNode
}

const AdminContainer = ({children}: IProps) => {

    const user = useAppSelector(getUser)

    if (user && checkRole([EnumRoles.admin, EnumRoles.moderator], user.role)) {
        return (
            <>
                {children}
            </>
        )
    }

    return null
};

export default AdminContainer;